import _pick from 'lodash/pick'
import * as types from '@/constants/store-mutation-types'
import { pointTemplate } from '@/constants/order/order-object-template'

import VeeValidateFa from 'vee-validate/dist/locale/fa'
import moment from 'moment-jalaali'

import { remove as removeData, set as setData } from '@/lib/local-storage'

const mergePoint = (point) => {
  if (!point) return null

  const normalizedPoint = {
    ...pointTemplate,
    ...point,
    latitude:
      (point.point && point.point.lat) || point.lat || point.latitude || null,
    longitude:
      (point.point && point.point.lng) || point.lng || point.longitude || null
  }

  return _pick(normalizedPoint, Object.keys(pointTemplate))
}

export default {
  [types.SET_LOCALE]: (state, { value, validator, i18n }) => {
    state.$locale = value

    if (value == 'fa') {
      moment.loadPersian({ dialect: 'persian-modern' })
      if (validator) validator.localize('fa', VeeValidateFa)
    } else {
      if (validator) validator.localize(value)
    }
    i18n.locale = value
    moment.locale(value)
    setData(types.LOCALE_COOKIE, value)
  },

  [types.SET_ACCOUNT]: (state, account) => {
    state.$account = account
  },

  [types.SET_PERMISSION]: (state, permissions) => {
    state.$permissions = permissions
  },

  [types.SET_CLIENT_TYPE]: (state, clientType) => {
    state.clientType = clientType
  },

  [types.SET_WEB_VIEW](state, webView) {
    state.webView = webView
  },

  [types.SET_FINGERPRINT](state, fingerprint) {
    state.fingerprint = fingerprint
  },

  [types.SET_BREADCRUMB]: (state, value) => {
    state.breadcrumb = value
  },

  [types.SET_REFRESHED_TOKEN]: (state, value) => {
    state.$account.accessToken = value.accessToken
    state.$account.ttl = value.ttl
    setData(types.ACCOUNT_COOKIE, state.$account)
  },

  [types.LOGOUT]: (state) => {
    state.$account = null
    state.firebaseMessagingToken = null
    removeData(types.ACCOUNT_COOKIE)
  },

  [types.SET_UPLOAD_PROGRESS]: (state, value) => {
    state.$uploadProgress = value
  },

  [types.SET_DOWNLOAD_PROGRESS]: (state, value) => {
    state.$downloadProgress = value
  },

  [types.SET_OFFLINE]: (state, value) => {
    state.$offline = value
  },

  [types.SET_MAP_OPTIONS](state, value) {
    state.mapOptions = value
  },
  //  ----------- register order ----------
  [types.CHANGE_COORDINATES]: (state, { point, range, payload }) => {
    state.order[point].latitude = payload.latLng.lat
    state.order[point].longitude = payload.latLng.lng
    state.order[point].address = payload.address.formatted

    if (range === 'urban') {
      state.order[point].cityId = payload.city.id
    }
  },
  [types.RESET_COORDINATES]: (state, { range, resetWhat }) => {
    if (resetWhat === 'both' || resetWhat === 'origin') {
      state.order.origin.latitude = null
      state.order.origin.longitude = null
      state.order.origin.address = null
      if (range === 'urban') state.order.origin.cityId = null
    }

    if (resetWhat === 'both' || resetWhat === 'destination') {
      state.order.destination.latitude = null
      state.order.destination.longitude = null
      state.order.destination.address = null
      if (range === 'urban') state.order.destination.cityId = null
    }
  },
  [types.CHANGE_POINT_INFO_BY_KEY]: (state, { point, key, value }) => {
    state.order[point][key] = value
  },
  [types.CHANGE_ORDER_BY_KEY]: (state, { key, value }) => {
    state.order[key] = value
  },
  [types.LOAD_ORDER]: (state, { order, loadDates = false }) => {
    state.order.userId = order.userId
    state.order.rangeId = order.rangeId
    state.order.typeId = order.typeId

    state.order.car = order.car

    state.order.estimatedPolyline = order.estimatedPolyline
    state.order.estimatedDistanceMeter = order.estimatedDistanceMeter
    state.order.estimatedDurationSecond = order.estimatedDurationSecond

    state.order.templateId = order.templateId
    state.order.draftUuid = order.draftUuid

    state.order.description = order.description
    state.order.initiatedCompanyId = order.initiatedCompanyId

    const { origin, destination, typeId } = order

    state.order.origin = {
      ...state.order.origin,
      latitude: origin.latitude,
      longitude: origin.longitude,
      name: origin.name,
      mobile: origin.mobile,
      address: origin.address,
      addressId: origin.addressId,
      cityId: origin.cityId,
      provinceId: origin.province.id
    }

    state.order.destination = {
      ...state.order.destination,
      latitude: destination.latitude,
      longitude: destination.longitude,
      name: destination.name,
      mobile: destination.mobile,
      address: destination.address,
      addressId: destination.addressId,
      provinceId: destination.province.id,
      cityId: destination.cityId
    }

    if (loadDates) state.order.orderTime = order.orderTime

    if (typeId === 10) {
      // furniture order
      state.order.origin = {
        ...state.order.origin,
        plate: origin.plate,
        unit: origin.unit,
        floor: origin.floor,
        carDistanceMeter: origin.carDistanceMeter,
        elevator: origin.elevator
      }

      state.order.destination = {
        ...state.order.destination,
        plate: destination.plate,
        unit: destination.unit,
        floor: destination.floor,
        carDistanceMeter: destination.carDistanceMeter,
        elevator: destination.elevator
      }

      state.order.employee = order.employee
      state.order.item = order.item

      state.order.withCar = !!order.car.length
    } else {
      // cargo order
      state.order.loadId = order.loadId
      state.order.packageId = order.packageId

      state.order.monetaryValue = order.monetaryValue

      state.order.weightKilogram = order.weightKilogram
      state.order.lengthMeter = order.lengthMeter
      state.order.widthMeter = order.widthMeter
      state.order.heightMeter = order.heightMeter

      if (loadDates) {
        state.order.dischargeTime = order.dischargeTime
        state.order.dischargeDayPartId = order.dischargeDayPartId
      }
    }
  },
  /* -------new order-------- */
  [types.SET_ORDER_TYPE]: (state, type) => {
    if (typeof type === 'number') {
      state.order.properties.orderTypeId = state.order.data.typeId = type
    } else {
      state.order.properties.orderTypeId = state.order.types.find(
        (orderType) => orderType.slug === type
      ).id
      state.order.data.typeId = state.order.properties.orderTypeId
    }
  },
  [types.SET_ORDER_RANGE]: (state, rangeId) => {
    state.order.properties.orderRangeId = rangeId
    state.order.data.rangeId = rangeId
  },
  [types.SET_SELECTED_COMPANY]: (state, courier) => {
    state.order.properties.selectedCourier = {
      id: courier.id,
      title: courier.title,
      brand: courier.brand,
      image: courier.image,
      slug: courier.slug
    }
    state.order.data.courierIds = [courier.id]
  },
  [types.SET_POINT_INFO]: (
    state,
    {
      point,
      lat = null,
      lng = null,
      cityId = null,
      address = null,
      _address = null
    }
  ) => {
    if (!_address) {
      state.order.data[point].latitude = lat || state.order.data[point].latitude
      state.order.data[point].longitude =
        lng || state.order.data[point].longitude
      state.order.data[point].cityId = cityId || state.order.data[point].cityId
      state.order.data[point].address =
        address || state.order.data[point].address
    } else {
      state.order.data[point].addressId = _address.id
      state.order.data[point].latitude = _address.latitude
      state.order.data[point].longitude = _address.longitude
      state.order.data[point].cityId = _address.cityId
      state.order.data[point].address = _address.address
      state.order.data[point].phone = _address.phone
      state.order.data[point].mobile = _address.mobile
      state.order.data[point].zipCode = _address.zipCode
      state.order.data[point].plate = _address.plate
      state.order.data[point].floor = _address.floor
      state.order.data[point].unit = _address.unit
    }
  },
  [types.CLEAR_POINT_INFO]: (state, point) => {
    state.order.data[point].addressId = null
    state.order.data[point].latitude = null
    state.order.data[point].longitude = null
    state.order.data[point].cityId = null
    state.order.data[point].address = null
    state.order.data[point].phone = null
    state.order.data[point].mobile = null
    state.order.data[point].zipCode = null
    state.order.data[point].plate = null
    state.order.data[point].floor = null
    state.order.data[point].unit = null
  },
  [types.SET_POINT_INFO_BY_KEY]: (state, { point, key, value }) => {
    state.order.data[point][key] = value
  },
  [types.SET_MIDDLE_POINT_INFO_BY_INDEX]: (state, { index, key, value }) => {
    state.order.data.middlePoints[index][key] = value
  },
  [types.UPDATE_ORDER_BY_KEY]: (state, { key, value }) => {
    state.order.data[key] = value
  },
  [types.CHANGE_ORDER_WITH_CAR]: (state, value) => {
    state.order.properties.withCar = value
    if (value) {
      // remove simple employee from list of employees that user can select
      state.order.fetchedLists.employee.list =
        state.order.fetchedLists.employee.list.filter((employee) => {
          return employee.id !== 1
        })
    } else {
      // add simple employee to list of employees that user can select
      state.order.fetchedLists.employee.list.push({
        id: 1,
        image: 'laborer.png',
        title: 'کارگر حمل بار'
      })
    }
  },
  [types.SET_FETCHED_LIST_DATE]: (state, { list, data }) => {
    state.order.fetchedLists[list] = data
  },
  [types.SET_ORDER_OFFERS]: (state, offers) => {
    state.order.data.acceptedOffers = offers
  },
  [types.RESET_STORE]: (state) => {
    state.order = {
      ...state.order,
      properties: {
        orderTypeId: null,
        orderRangeId: null,
        selectedCourier: null,
        withCar: true
      },
      fetchedLists: {
        car: {
          filter: {
            typeId: null,
            rangeId: null
          },
          list: []
        },
        employee: {
          filter: {
            typeId: null,
            rangeId: null
          },
          list: []
        },
        item: {
          filter: {
            typeId: null,
            rangeId: null
          },
          list: []
        },
        load: {
          filter: {
            typeId: null,
            rangeId: null
          },
          list: []
        },
        carLoad: {
          filter: {
            typeId: null,
            rangeId: null
          },
          list: []
        }
      },
      data: {
        origin: {
          cityId: null,
          latitude: null,
          longitude: null,
          address: null,
          addressId: null,
          name: null,
          mobile: null,
          phone: null,
          zipCode: null,
          plate: null,
          floor: null,
          unit: null,
          elevator: false,
          carDistanceMeter: 10,
          postalCode: null,
          weighbridgeWeight: null,
          weighbridgeReceiptFile: null
        },
        destination: {
          cityId: null,
          latitude: null,
          longitude: null,
          address: null,
          addressId: null,
          name: null,
          mobile: null,
          phone: null,
          zipCode: null,
          plate: null,
          floor: null,
          unit: null,
          elevator: false,
          carDistanceMeter: 10,
          postalCode: null,
          weighbridgeWeight: null,
          weighbridgeReceiptFile: null
        },
        attachments: null,
        image: null,
        middlePoints: [],
        typeId: null,
        rangeId: null,
        orderTime: null,
        dischargeTime: null,
        dischargeDayPartId: null,
        car: [],
        packageType: [],
        employee: [],
        item: [],
        packagge: [
          {
            typeId: {
              name: 'کارتن',
              value: 1,
              enum: 'PACK',
              icon: '',
              weightDetermination: 1000,
              weightLabel: 'کیلوگرم',
              weightMin: 0.5,
              weightMax: 25,
              isKiloGrams: true
            },
            count: 1,
            weightGram: null,
            monetaryValue: null,
            content: null
          }
        ],
        loadId: null,
        packageId: null,
        monetaryValue: null,
        weightKilogram: null,
        heightMeter: null,
        lengthMeter: null,
        widthMeter: null,
        templateId: null,
        estimatedDistanceMeter: null,
        estimatedDurationSecond: null,
        estimatedPolyline: [],
        companyIds: null,
        initiatedCompanyId: null,
        description: null,
        title: null,
        timeSheetTemplateId: null,
        timeSheetDate: null,
        sendMethodId: null,
        waitMinute: null,
        roundTrip: false,
        reserveOrder: false,
        // helper fields
        userId: null,
        selectedCourierIds: [],
        selectedTimeSheetTemplate: null,
        acceptedOffers: []
      }
    }
  },
  [types.SET_ENTIRE_ORDER]: (state, data) => {
    state.order.data = {
      ...state.order.data,
      ...data
    }
  },
  [types.SET_FIREBASE_MESSAGING_TOKEN]: (state, token) => {
    state.firebaseMessagingToken = token
  },

  // --- create Shipment Refactor --- //
  [types.SET_ORDER_CONFIG](state, value) {
    state.orderConfig = value
  },
  [types.SET_ORDER_OBJECT](state, value) {
    state.orderObject = value
  },
  [types.SET_ORDER_STEP](state, value) {
    state.orderStep = value
  },
  [types.SET_ORDER_STEP_SECTION](state, value) {
    state.orderStepSection = value
  },
  [types.WIPE_ORDER_DATA](state) {
    state.orderConfig = null
    state.orderObject = {}
    state.orderStep = null
    state.orderStepSection = null
  },
  [types.SET_ORDER_POINT_DATA](state, payload) {
    state.orderObject[payload.point] = {
      ...state.orderObject[payload.point],
      ...{
        latitude: payload.latLng ? payload.latLng.lat : null,
        longitude: payload.latLng ? payload.latLng.lng : null,
        cityId: payload.city ? payload.city.id : null,
        address: payload.address ? payload.address.formatted : null
      }
    }
  },
  [types.SET_ORDER_DATA_BY_KEY](state, { key, value }) {
    state.orderObject[key] = value
  },
  [types.SET_ORDER_POINT_DATA_BY_KEY](state, { point, key, value }) {
    state.orderObject[point][key] = value
  },
  [types.REGISTER_ORDER_NEXT_STEP](state) {
    if (state.orderStep.index < state.orderConfig.steps.length - 1) {
      state.orderStep = state.orderConfig.steps[state.orderStep.index + 1]
    }
  },
  [types.REGISTER_ORDER_PREV_STEP](state) {
    if (state.orderStep.index !== 0) {
      state.orderStep = state.orderConfig.steps[state.orderStep.index - 1]
    }
  },
  [types.SET_ORDER_CACHE_DATA_BY_KEY](state, { key, value }) {
    state.orderDataCache[key] = value
  },
  [types.SET_ORDER_ACCEPTED_OFFERS](state, { offers, uniqueId }) {
    state.orderAcceptedOffers = offers
    state.orderSuccessUniqueId = uniqueId
  },
  [types.SET_ORDER_PACKAGE_FIELD_BY_INDEX_AND_KEY](
    state,
    { index, key, value }
  ) {
    state.orderObject.packagge[index][key] = value
  },
  [types.WIPE_ORDER_POINT_DATA](state, point) {
    if (Object.prototype.hasOwnProperty.call(state.orderObject, point)) {
      if (point === 'middlePoints') {
        state.orderObject.middlePoints = []
        return
      }

      Object.keys(state.orderObject[point]).forEach((key) => {
        state.orderObject[point][key] =
          key === 'carDistanceMeter' ? 10 : key === 'elevator' ? false : null
      })
    }
  },
  [types.SET_USER_DATA](state, payload) {
    state.userObject = payload
  },
  [types.SET_ORDER_MIDDLE_POINT_DATA_BY_INDEX](state, { index, key, value }) {
    state.orderObject.middlePoints[index][key] = value
  },
  [types.REGISTER_ORDER_SET_STEP](state, { slug, destinationSlug }) {
    const step = state.orderConfig.steps.find((step) => step.slug === slug)

    state.orderStep = { ...step, destinationSlug }
  },
  [types.SET_ORDER_ACCEPTED_OFFERS](state, { offers, uniqueId }) {
    state.orderAcceptedOffers = offers
    state.orderSuccessUniqueId = uniqueId
  },
  [types.SET_ORDER_POINT_DATA_BY_SAVED_ADDRESS](state, payload) {
    state.orderObject[payload.point] = {
      ...state.orderObject[payload.point],
      addressId: payload.poi ? null : payload.id,
      poiId: payload.poi ? payload.id : null,
      latitude: payload.latitude,
      longitude: payload.longitude,
      cityId: payload.cityId,
      address: payload.address,
      phone: payload.phone,
      mobile: payload.mobile,
      zipCode: payload.zipCode,
      plate: payload.plate,
      floor: payload.floor,
      unit: payload.unit
    }
  },

  //new-register-order

  [types.SET_ORDER_POINTS](state, points) {
    const isCargoOrder = state.orderObject.typeId === 20

    const origin = points.length ? points[0] : null
    state.orderObject.origin = mergePoint({
      ...origin,
      operationId: isCargoOrder ? 1 : null
    })

    const destinations =
      points.length && points.length > 1
        ? points.splice(1, points.length - 1)
        : []

    state.orderObject.destinations = destinations.map((destination, index) =>
      mergePoint({
        ...destination,
        operationId: isCargoOrder
          ? index < destinations.length - 1
            ? destination.operationId || 2
            : 2
          : null
      })
    )
  },

  [types.SET_ORDER_POINT_DATA_BY_INDEX_KEY](state, { index, key, value }) {
    const isCargoOrder = state.orderObject.typeId === 20

    if (index === 0) {
      if (state.orderObject.origin) {
        state.orderObject.origin[key] = value
      } else {
        const data = { [key]: value }

        if (isCargoOrder) {
          data.operationId = 1
        }

        state.orderObject.origin = mergePoint(data)
      }
    } else {
      const destinationIndex = index - 1

      if (destinationIndex < state.orderObject.destinations.length) {
        state.orderObject.destinations[destinationIndex][key] = value
      } else if (destinationIndex === state.orderObject.destinations.length) {
        const data = { [key]: value }

        if (isCargoOrder) {
          data.operationId = 2
        }

        state.orderObject.destinations.push(mergePoint(data))
      }
      // reassign destinations to reactivity works probably
      state.orderObject.destinations = [...state.orderObject.destinations]
    }
  },
  [types.REMOVE_ORDER_POINT_BY_INDEX](state, index) {
    if (index === 0) {
      state.orderObject.origin = null
    } else {
      const destinationIndex = index - 1

      if (destinationIndex < state.orderObject.destinations.length) {
        state.orderObject.destinations.splice(destinationIndex, 1)

        if (state.orderObject.typeId === 20) {
          state.orderObject.destinations = state.orderObject.destinations.map(
            (point, index) => {
              return {
                ...point,
                operationId:
                  index === state.orderObject.destinations.length - 1
                    ? 2
                    : point.operationId || 2
              }
            }
          )
        }
      }
    }
  }
}
